module.exports = __webpack_public_path__ + "files/724f4c2754161385cfc1c21216d3c795.png";